import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { ValueProp } from './components/ValueProp';
import { Includes } from './components/Includes';
import { Bonuses } from './components/Bonuses';
import { TargetAudience } from './components/TargetAudience';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofToast } from './components/SocialProofToast';
export function App() {
  useEffect(() => {
    // Meta Pixel Initialization
    const pixelId = '26257470350562748';
    !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        ;
        (b.head || b.documentElement).appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // @ts-ignore
    window.fbq('init', pixelId);
    // @ts-ignore
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen font-sans selection:bg-brand-gold selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <ValueProp data-id="element-2" />
      <Includes data-id="element-3" />
      <Bonuses data-id="element-4" />
      <TargetAudience data-id="element-5" />
      <Pricing data-id="element-6" />
      <Testimonials data-id="element-7" />
      <FAQ data-id="element-8" />
      <Footer data-id="element-9" />
      <SocialProofToast data-id="element-10" />
    </div>;
}